module.exports = "/build/web/images/review-image-2.38f84acc606e7ae5c7710c66071242bb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./images/review-image-2.jpeg
// module id = 132
// module chunks = 11